import Swiper from "swiper/bundle";

export const initReviewsCarousel = () => {
  const reviewsSwiperContainer = document.querySelector('.reviews-carousel__list');
  const reviewsSlider = new Swiper( reviewsSwiperContainer, {
    slidesPerView: 3,
    spaceBetween: 40,
    mousewheel: true,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 6000,
    },
    breakpoints: {
      320: {
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: true,
        mousewheel: {
          forceToAxis: true,
          invert: true,
        }
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
        centeredSlides: false,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 40,
        centeredSlides: false,
      },
    },
  });
};
